/**
 * Apollo Client 4 removed ApolloConsumer. This shim restores the render-prop
 * API used across the app via useApolloClient.
 */
import { useApolloClient } from '@apollo/client/react'

export function ApolloConsumer({ children  }) {
  const client = useApolloClient()
  return children(client)
}

export default ApolloConsumer
